import { render } from "./zhuanpei.vue?vue&type=template&id=88fe0a22&scoped=true"
import script from "./zhuanpei.vue?vue&type=script&lang=js"
export * from "./zhuanpei.vue?vue&type=script&lang=js"

import "./zhuanpei.vue?vue&type=style&index=0&id=88fe0a22&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88fe0a22"]])

export default __exports__